export default __webpack_public_path__ + "static/5-structs-1c9c2f9d0136b0ca7ce37229f5e4ae46.jpg";